import * as Yup from 'yup';

export const INVALID_FIELDS = {
  EMAIL: 'validation.messages.email',
  REQUIRED: 'validation.messages.required',
  MIN_NUMBER: 'validation.messages.minNumber',
  PASSWORD_CODE: 'validation.messages.passwordCode',
  PASSWORD_MATCH: 'validation.messages.passwordMatch',
  PREFIX_INVALID: 'validation.messages.prefixInvalid',
  MIN_COLLECTION: 'validation.messages.mustBeAtLeast1Collection',
  MIN_REPORT_TYPE: 'validation.messages.mustBeAtLeast1ReportType',
  MIN_SAMPLE_TYPE: 'validation.messages.mustBeAtLeast1SampleType',
  MIN_OUTPUT_TYPE: 'validation.messages.mustBeAtLeast1OutputType',
  MIN_SYSTEM: 'validation.messages.mustBeAtLeast1System',
  MIN_SELECTION: 'validation.messages.mustBeAtLeast1',
  PASSWORD_PATTERN: 'validation.messages.passwordPattern',
  MIN_ORGANIZATION: 'validation.messages.mustBeAtLeast1Organization',
  SUB_DOMAIN: 'validation.messages.invalidSubdomainFormat',
  OVERLAP_ITEM: 'validation.messages.overlapItem',
  OVERLAP_PRICE_RANGE: 'validation.messages.overlapPriceRange',
  POSITIVE_NUMBER: 'validation.messages.positiveNumber',
  INTEGER_NUMBER: 'validation.messages.integerNumber',
  MIN_PDF_LANGUAGE_OPTION:
    'validation.messages.mustBeAtLeast1PdfLanguageOption',
  MAX_NUMBER: 'validation.messages.maxNumber',
  WRONG_FORMAT: 'validation.messages.wrongFormat',
  LENGTH_NOT_MATCH: 'validation.messages.lengthNotMatch',
  MIN_EMAIL_RECIPIENT: 'validation.messages.mustBeAtLeast1EmailRecipient',
};

/** The pattern can cover the conditions that are feasible with regex:
 * 1. At least 8 characters long
 * 2. Contains at least one digit
 * 3. Contains at least one uppercase letter and at least one lowercase letter
 * 4. Contains at least one special character @#$!%*?&_-~
 */
export const passwordPatternChecking =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$!%*?&_\-~])[A-Za-z\d@#$!%*?&_\-~]{8,}$/;

export const serialPatternRegex =
  /^[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}$/;

export const YupStringWithoutRequired = Yup.string();

export const YupString = YupStringWithoutRequired.required(
  INVALID_FIELDS.REQUIRED,
);

export const YupNumber = Yup.number()
  .positive(INVALID_FIELDS.POSITIVE_NUMBER)
  .nullable();
